import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';
import LinearProgress from '@mui/material/LinearProgress';
import StorefrontIcon from '@mui/icons-material/Storefront';
import BoltIcon from '@mui/icons-material/Bolt';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import SensorsIcon from '@mui/icons-material/Sensors';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import PaidOutlinedIcon from '@mui/icons-material/PaidOutlined';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import BetaChip from '../components/BetaChip';
import TermsDialog from '../components/TermsDialog';
import homeCard1 from '../assets/cards/homecard1.png';
import homeCard2 from '../assets/cards/homecard2.png';
import homeCard3 from '../assets/cards/homecard3.png';
import charizardExSir from '../assets/cards/charizard-ex-sir.jpg';
import carouselC1 from '../assets/carrousel/c1.jpg';
import carouselC2 from '../assets/carrousel/c2.png.webp';
import carouselC3 from '../assets/carrousel/c3.png';
import carouselC4 from '../assets/carrousel/c4.webp';
import carouselC5 from '../assets/carrousel/c5.png';
import carouselC7 from '../assets/carrousel/c7.jpg';
import mascotVentasVivo from '../assets/mascot/Bidoo_VentasVivo.png';
import mascotDashboard from '../assets/mascot/Bidoo_DashboardTiendas.png';
import mascotReputacion from '../assets/mascot/Bidoo_Reputacion.png';
import mascotPreguntas from '../assets/mascot/Biddo_Preguntas.png';
import mascotQuestionMark from '../assets/mascot/Bidoo_QuestionMark.png';
import mascotQuestionMark2 from '../assets/mascot/Bidoo_QuestionMark2.png';
import './HomePage.css';

const ELECTRIC_BLUE = '#00C2FF';
const ELECTRIC_PURPLE = '#7B2FF7';

const PURPLE_BUTTON_SX = {
    bgcolor: ELECTRIC_PURPLE,
    color: '#ffffff',
    fontWeight: 700,
    borderRadius: 999,
    border: 'none',
    boxShadow: '0 6px 6px rgba(100,32,208,0.35), 0 16px 36px rgba(123,47,247,0.3)',
    transition: 'transform 0.15s ease, box-shadow 0.15s ease, background-color 0.2s ease',
    '&:hover': {
        bgcolor: ELECTRIC_PURPLE,
        boxShadow: '0 9px 10px rgba(100,32,208,0.4), 0 22px 46px rgba(123,47,247,0.38)',
        transform: 'translateY(-3px)',
    },
    '&:active': {
        boxShadow: '0 2px 5px rgba(100,32,208,0.32), 0 6px 18px rgba(123,47,247,0.25)',
        transform: 'translateY(4px)',
    },
};

const SECONDARY_FEATURES = [
    { icon: MeetingRoomIcon, label: 'Salas privadas por código' },
    { icon: WorkspacePremiumIcon, label: 'Niveles de Coleccionista' },
    { icon: EmojiEventsIcon, label: 'Historial de subastas ganadas' },
];

function PhoneFrame({ children }) {
    return (
        <Box
            className="feature-mockup-frame phone-frame"
            sx={{
                position: 'relative',
                width: '100%',
                maxWidth: 300,
                mx: 'auto',
                bgcolor: '#050506',
                borderRadius: '46px',
                border: '1px solid rgba(255,255,255,0.14)',
                p: '12px',
            }}
        >
            <Box className="phone-frame-button phone-frame-button--power" />
            <Box className="phone-frame-button phone-frame-button--volume-up" />
            <Box className="phone-frame-button phone-frame-button--volume-down" />
            <Box
                sx={{
                    position: 'relative',
                    bgcolor: '#0d0d0f',
                    borderRadius: '34px',
                    overflow: 'hidden',
                    minHeight: 420,
                }}
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: 10,
                        left: '50%',
                        transform: 'translateX(-50%)',
                        width: 84,
                        height: 22,
                        bgcolor: '#000',
                        borderRadius: '14px',
                        zIndex: 2,
                    }}
                />
                <Box sx={{ pt: '44px', px: 2, pb: 2.5 }}>{children}</Box>
            </Box>
        </Box>
    );
}

function DashboardMockup() {
    const bars = [38, 62, 48, 80, 55, 90, 70];
    const stats = [
        { icon: PaidOutlinedIcon, label: 'Ventas Totales', value: '$128,450 mxn' },
        { icon: StorefrontIcon, label: 'Subastas Activas', value: '6' },
        { icon: TrendingUpIcon, label: 'Crecimiento', value: '+24%' },
    ];
    return (
        <PhoneFrame>
            <Typography sx={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.72rem', fontWeight: 600, mb: 2, textAlign: 'center' }}>
                Panel de Tienda · Resumen
            </Typography>
            <Stack spacing={1} sx={{ mb: 2.5 }}>
                {stats.map((stat) => (
                    <Stack
                        key={stat.label}
                        direction="row"
                        alignItems="center"
                        justifyContent="space-between"
                        sx={{ bgcolor: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.06)', borderRadius: '14px', px: 1.5, py: 1 }}
                    >
                        <Stack direction="row" alignItems="center" spacing={1}>
                            <Box
                                sx={{
                                    width: 28,
                                    height: 28,
                                    borderRadius: '9px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    bgcolor: 'rgba(0,194,255,0.12)',
                                    flexShrink: 0,
                                }}
                            >
                                <stat.icon sx={{ color: ELECTRIC_BLUE, fontSize: 15 }} />
                            </Box>
                            <Typography sx={{ color: 'rgba(255,255,255,0.55)', fontSize: '0.7rem' }}>{stat.label}</Typography>
                        </Stack>
                        <Typography sx={{ color: '#fff', fontWeight: 700, fontSize: '0.85rem' }}>{stat.value}</Typography>
                    </Stack>
                ))}
            </Stack>
            <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 0.75, height: 70 }}>
                {bars.map((h, i) => (
                    <Box
                        key={i}
                        sx={{
                            flex: 1,
                            height: `${h}%`,
                            borderRadius: '5px 5px 0 0',
                            background: i === 5 ? ELECTRIC_BLUE : 'rgba(0,194,255,0.22)',
                        }}
                    />
                ))}
            </Box>
        </PhoneFrame>
    );
}

function LiveAuctionMockup() {
    const bids = [
        { name: 'Miguel R.', amount: '$4,250 mxn' },
        { name: 'Ana L.', amount: '$4,100 mxn' },
        { name: 'Jorge S.', amount: '$3,900 mxn' },
    ];
    return (
        <PhoneFrame>
            <Box sx={{ position: 'relative', mb: 1.75, borderRadius: '16px', overflow: 'hidden' }}>
                <Box
                    component="img"
                    src={charizardExSir}
                    alt="Charizard ex SIR"
                    sx={{ width: '100%', display: 'block', aspectRatio: '5 / 7', objectFit: 'cover' }}
                />
                <Chip
                    size="small"
                    icon={<Box className="live-dot" sx={{ width: 7, height: 7, borderRadius: '50%', bgcolor: '#ff5252 !important', ml: '6px !important' }} />}
                    label="EN VIVO"
                    sx={{
                        position: 'absolute',
                        top: 8,
                        left: 8,
                        bgcolor: 'rgba(10,10,11,0.75)',
                        color: '#ff8a8a',
                        fontWeight: 700,
                        border: '1px solid rgba(255,82,82,0.4)',
                        fontSize: '0.66rem',
                        backdropFilter: 'blur(4px)',
                    }}
                />
                <Box
                    sx={{
                        position: 'absolute',
                        top: 8,
                        right: 8,
                        bgcolor: 'rgba(10,10,11,0.75)',
                        borderRadius: '8px',
                        px: 1,
                        py: 0.4,
                        backdropFilter: 'blur(4px)',
                    }}
                >
                    <Typography sx={{ color: 'rgba(255,255,255,0.8)', fontSize: '0.62rem', letterSpacing: '0.08em', lineHeight: 1 }}>
                        AB3F9K
                    </Typography>
                </Box>
            </Box>
            <Typography sx={{ color: 'rgba(255,255,255,0.55)', fontSize: '0.78rem', mb: 0.5 }}>
                Charizard ex SIR · 199/165
            </Typography>
            <Stack direction="row" alignItems="baseline" spacing={1.25} sx={{ mb: 2.25 }}>
                <Typography sx={{ color: ELECTRIC_BLUE, fontWeight: 800, fontSize: '1.7rem', lineHeight: 1 }}>
                    $4,250 <Box component="span" sx={{ fontSize: '0.95rem', fontWeight: 700 }}>mxn</Box>
                </Typography>
                <Chip
                    size="small"
                    icon={<SensorsIcon sx={{ fontSize: '13px !important' }} />}
                    label="00:42"
                    sx={{ bgcolor: 'rgba(255,255,255,0.06)', color: '#fff', fontWeight: 700, fontSize: '0.7rem' }}
                />
            </Stack>
            <Stack spacing={0.85}>
                {bids.map((bid, i) => (
                    <Stack
                        key={bid.name}
                        direction="row"
                        alignItems="center"
                        justifyContent="space-between"
                        sx={{
                            bgcolor: i === 0 ? 'rgba(123,47,247,0.08)' : 'rgba(255,255,255,0.03)',
                            border: '1px solid rgba(255,255,255,0.06)',
                            borderRadius: '12px',
                            px: 1.25,
                            py: 0.75,
                        }}
                    >
                        <Stack direction="row" alignItems="center" spacing={1}>
                            <Avatar sx={{ width: 20, height: 20, fontSize: '0.6rem', bgcolor: '#1c1c1e', color: ELECTRIC_BLUE }}>
                                {bid.name[0]}
                            </Avatar>
                            <Typography sx={{ color: 'rgba(255,255,255,0.75)', fontSize: '0.75rem' }}>{bid.name}</Typography>
                        </Stack>
                        <Typography sx={{ color: '#fff', fontWeight: 700, fontSize: '0.75rem' }}>{bid.amount}</Typography>
                    </Stack>
                ))}
            </Stack>
        </PhoneFrame>
    );
}

function ReputationMockup() {
    return (
        <PhoneFrame>
            <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1} sx={{ mb: 1.5 }}>
                <Typography sx={{ color: '#fff', fontWeight: 700, fontSize: '0.9rem' }}>Reputación</Typography>
                <Chip
                    size="small"
                    icon={<WorkspacePremiumIcon sx={{ fontSize: '15px !important' }} />}
                    label="Coleccionista"
                    sx={{ fontWeight: 700, fontSize: '0.68rem', bgcolor: ELECTRIC_PURPLE, color: '#fff' }}
                />
            </Stack>
            <Typography sx={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.8rem', mb: 1 }}>1,240 pts</Typography>
            <LinearProgress
                variant="determinate"
                value={62}
                sx={{
                    height: 8,
                    borderRadius: 4,
                    mb: 1.5,
                    bgcolor: 'rgba(255,255,255,0.08)',
                    '& .MuiLinearProgress-bar': { bgcolor: ELECTRIC_PURPLE },
                }}
            />
            <Typography sx={{ color: 'rgba(255,255,255,0.55)', fontSize: '0.75rem', mb: 2.25 }}>
                Completa 3 ventas más para subir de nivel.
            </Typography>
            <Stack direction="row" flexWrap="wrap" useFlexGap spacing={0.75}>
                {['Casual', 'Coleccionista', 'Maestro', 'Leyenda'].map((lvl) => (
                    <Chip
                        key={lvl}
                        size="small"
                        label={lvl}
                        sx={{
                            bgcolor: lvl === 'Coleccionista' ? 'rgba(123,47,247,0.16)' : 'rgba(255,255,255,0.05)',
                            color: lvl === 'Coleccionista' ? ELECTRIC_PURPLE : 'rgba(255,255,255,0.4)',
                            fontWeight: 600,
                            fontSize: '0.62rem',
                        }}
                    />
                ))}
            </Stack>
        </PhoneFrame>
    );
}

const MAIN_FEATURES = [
    {
        key: 'live',
        title: 'Ventas en Vivo',
        description:
            'Transmite tus subastas en vivo y deja que los coleccionistas pujen en tiempo real. Cada oferta se actualiza al instante hasta el último segundo del remate, con salas accesibles por código.',
        Mockup: LiveAuctionMockup,
        mascot: mascotVentasVivo,
    },
    {
        key: 'dashboard',
        title: 'Dashboard de Tiendas',
        description:
            'Cada tienda cuenta con su propio panel para gestionar subastas, revisar estadísticas de ventas en tiempo real y personalizar su marca. Todo lo necesario para vender sin complicaciones.',
        Mockup: DashboardMockup,
        mascot: mascotDashboard,
    },
    {
        key: 'reputation',
        title: 'Sistema de Reputación',
        description:
            'Compradores y tiendas construyen su reputación con cada transacción. Sube de nivel — Casual, Coleccionista, Maestro, Leyenda — y genera más confianza dentro de la comunidad.',
        Mockup: ReputationMockup,
        mascot: mascotReputacion,
    },
];

function FeatureMockupWithMascot({ feature }) {
    const { Mockup, mascot, title } = feature;
    return (
        <Box sx={{ position: 'relative', maxWidth: 300, mx: 'auto' }}>
            <Mockup />
            <Box
                component="img"
                src={mascot}
                alt={`Mascota PlayBid · ${title}`}
                className="feature-mascot"
                aria-hidden="true"
            />
        </Box>
    );
}

function FeatureAccordionItem({ feature, isOpen, onToggle }) {
    return (
        <Box sx={{ borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
            <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                spacing={2}
                onClick={onToggle}
                sx={{ cursor: 'pointer', py: { xs: 2.25, sm: 2.75 } }}
            >
                <Typography
                    sx={{
                        fontSize: { xs: '1.15rem', sm: '1.4rem' },
                        fontWeight: 800,
                        letterSpacing: '-0.01em',
                        color: isOpen ? '#fff' : 'rgba(255,255,255,0.5)',
                        transition: 'color 0.2s ease',
                    }}
                >
                    {feature.title}
                </Typography>
                <IconButton
                    size="small"
                    disableRipple
                    sx={{
                        flexShrink: 0,
                        width: 34,
                        height: 34,
                        color: isOpen ? ELECTRIC_PURPLE : 'rgba(255,255,255,0.4)',
                        border: '1px solid',
                        borderColor: isOpen ? 'rgba(123,47,247,0.4)' : 'rgba(255,255,255,0.16)',
                        transition: 'color 0.2s ease, border-color 0.2s ease',
                    }}
                >
                    {isOpen ? <RemoveIcon fontSize="small" /> : <AddIcon fontSize="small" />}
                </IconButton>
            </Stack>
            <Collapse in={isOpen} timeout={280} unmountOnExit>
                <Box sx={{ pb: { xs: 3, sm: 3.5 } }}>
                    <Typography sx={{ color: 'rgba(255,255,255,0.6)', fontSize: '0.95rem', lineHeight: 1.75, pr: { md: 4 } }}>
                        {feature.description}
                    </Typography>
                    <Box sx={{ display: { xs: 'block', md: 'none' }, mt: 3 }}>
                        <FeatureMockupWithMascot feature={feature} />
                    </Box>
                </Box>
            </Collapse>
        </Box>
    );
}

const CAROUSEL_ITEMS = [
    { src: carouselC1, alt: 'Carta de Disney Lorcana' },
    { src: carouselC2, alt: 'Carta de Yu-Gi-Oh!' },
    { src: carouselC3, alt: 'Carta de One Piece Card Game' },
    { src: carouselC4, alt: 'Carta de Magic: The Gathering' },
    { src: carouselC5, alt: 'Carta de Pokémon TCG' },
    { src: carouselC7, alt: 'Carta de Gundam Card Game' },
];

function CardCarousel({ items }) {
    const trackRef = useRef(null);
    const dragRef = useRef({ dragging: false, startX: 0, startScroll: 0 });

    const getSetWidth = () => {
        const track = trackRef.current;
        return track ? track.scrollWidth / 3 : 0;
    };

    useLayoutEffect(() => {
        const track = trackRef.current;
        if (!track) return undefined;
        track.scrollLeft = getSetWidth();
        const handleResize = () => {
            track.scrollLeft = getSetWidth();
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleScroll = () => {
        const track = trackRef.current;
        if (!track) return;
        const setWidth = getSetWidth();
        if (!setWidth) return;
        if (track.scrollLeft < setWidth * 0.5) {
            track.scrollLeft += setWidth;
        } else if (track.scrollLeft > setWidth * 1.5) {
            track.scrollLeft -= setWidth;
        }
    };

    const onMouseDown = (e) => {
        const track = trackRef.current;
        dragRef.current = { dragging: true, startX: e.pageX, startScroll: track.scrollLeft };
        track.classList.add('is-dragging');
    };
    const onMouseMove = (e) => {
        if (!dragRef.current.dragging) return;
        e.preventDefault();
        const track = trackRef.current;
        const delta = e.pageX - dragRef.current.startX;
        track.scrollLeft = dragRef.current.startScroll - delta;
    };
    const endDrag = () => {
        dragRef.current.dragging = false;
        trackRef.current?.classList.remove('is-dragging');
    };

    const looped = [...items, ...items, ...items];

    return (
        <Box
            ref={trackRef}
            className="carousel-track"
            onScroll={handleScroll}
            onMouseDown={onMouseDown}
            onMouseMove={onMouseMove}
            onMouseUp={endDrag}
            onMouseLeave={endDrag}
        >
            {looped.map((item, i) => (
                <Box key={i} className="carousel-item">
                    <Box component="img" src={item.src} alt={item.alt} draggable={false} />
                </Box>
            ))}
        </Box>
    );
}

function useInView(options) {
    const ref = useRef(null);
    const [inView, setInView] = useState(false);

    useEffect(() => {
        const node = ref.current;
        if (!node) return undefined;
        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                setInView(true);
                observer.disconnect();
            }
        }, options);
        observer.observe(node);
        return () => observer.disconnect();
    }, [options]);

    return [ref, inView];
}

function HomePage() {
    const [activeFeatureKey, setActiveFeatureKey] = useState(MAIN_FEATURES[0].key);
    const [privacyOpen, setPrivacyOpen] = useState(false);
    const activeFeature = MAIN_FEATURES.find((f) => f.key === activeFeatureKey);
    const [featuresRef, featuresInView] = useInView({ threshold: 0.1 });
    const [carouselRef, carouselInView] = useInView({ threshold: 0.15 });
    const [aboutRef, aboutInView] = useInView({ threshold: 0.25 });
    const [contactRef, contactInView] = useInView({ threshold: 0.25 });

    return (
        <Box
            sx={{
                minHeight: '100vh',
                background:
                    'radial-gradient(1100px circle at 12% -8%, rgba(0,194,255,0.18), transparent 45%), ' +
                    'radial-gradient(900px circle at 88% 15%, rgba(123,47,247,0.16), transparent 50%), ' +
                    'radial-gradient(800px circle at 50% 90%, rgba(123,47,247,0.10), transparent 55%), ' +
                    'linear-gradient(180deg, #0a0a0b 0%, #101012 45%, #0a0a0b 100%)',
                pb: { xs: 6, sm: 8 },
            }}
        >
            <Box className="home-section-hero" sx={{ px: { xs: 2, sm: 3, md: 4 }, pt: { xs: 2, sm: 3, md: 4 } }}>
                <Box
                    className="home-hero-panel"
                    sx={{
                        maxWidth: 1200,
                        mx: 'auto',
                        bgcolor: '#0a0a0b',
                        border: '1px solid rgba(255,255,255,0.08)',
                        borderRadius: '30px',
                        color: '#ffffff',
                        px: { xs: 2.5, sm: 5, md: 7 },
                        pt: { xs: 2.5, sm: 3 },
                        pb: { xs: 16, sm: 14 },
                    }}
                >
                    {/* Nav */}
                    <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: { xs: 4, sm: 6 } }}>
                        <Stack direction="row" alignItems="center" spacing={1.25}>
                            <Typography variant="h6" fontWeight={800} letterSpacing="-0.02em">
                                PlayBid
                            </Typography>
                            <BetaChip color={ELECTRIC_BLUE} />
                        </Stack>
                        <Stack direction="row" alignItems="center" spacing={3}>
                            <Button
                                component={RouterLink}
                                to="/store/login"
                                sx={{ display: { xs: 'none', sm: 'inline-flex' }, color: 'rgba(255,255,255,0.75)' }}
                            >
                                Vender con Nosotros
                            </Button>
                            <Button
                                component={RouterLink}
                                to="/auctions"
                                sx={{
                                    ...PURPLE_BUTTON_SX,
                                    display: { xs: 'none', sm: 'inline-flex' },
                                    px: 2.5,
                                }}
                            >
                                Ver Subastas
                            </Button>
                        </Stack>
                    </Stack>

                    {/* Hero content */}
                    <Box className="home-hero-fade" sx={{ textAlign: 'center', maxWidth: 780, mx: 'auto' }}>
                        <Chip
                            icon={<BoltIcon sx={{ color: `${ELECTRIC_PURPLE} !important` }} />}
                            label="Plataforma de Subastas"
                            sx={{
                                mb: 3,
                                bgcolor: 'rgba(255,255,255,0.06)',
                                color: 'rgba(255,255,255,0.85)',
                                border: '1px solid rgba(255,255,255,0.12)',
                                fontWeight: 600,
                            }}
                        />
                        <Typography
                            sx={{
                                fontSize: { xs: '2.5rem', sm: '3.75rem', md: '4.25rem' },
                                fontWeight: 800,
                                letterSpacing: '-0.03em',
                                lineHeight: 1.05,
                                mb: 3,
                            }}
                        >
                            Oferta en vivo.
                            <br />
                            Gana en grande.
                        </Typography>
                        <Typography sx={{ color: 'rgba(255,255,255,0.6)', fontSize: '1.05rem', mb: 4 }}>
                            Un mercado de subastas en vivo de tiendas independientes, con actualizaciones en tiempo real hasta el último segundo. No 
                            se requiere de tarjeta de crédito para ofertar, ni se cobran comisiones.
                        </Typography>
                        <Stack direction="row" spacing={2} justifyContent="center" alignItems="center">
                            <Button
                                component={RouterLink}
                                to="/auctions"
                                endIcon={<ArrowForwardIcon />}
                                size="large"
                                sx={{
                                    ...PURPLE_BUTTON_SX,
                                    px: 3.5,
                                    py: 1.25,
                                }}
                            >
                                Ver Subastas
                            </Button>
                            <IconButton
                                component="a"
                                href="#como-funciona"
                                aria-label="Bajar"
                                className="home-scroll-cta"
                                sx={{
                                    border: '1px solid rgba(255,255,255,0.2)',
                                    color: '#fff',
                                    width: 48,
                                    height: 48,
                                    transition: 'transform 0.15s ease, box-shadow 0.15s ease, border-color 0.2s ease, color 0.2s ease, background-color 0.2s ease',
                                    '&:hover': {
                                        borderColor: ELECTRIC_PURPLE,
                                        color: ELECTRIC_PURPLE,
                                        bgcolor: 'rgba(123,47,247,0.08)',
                                        boxShadow: '0 8px 18px rgba(123,47,247,0.35)',
                                        transform: 'translateY(-3px)',
                                    },
                                }}
                            >
                                <KeyboardArrowDownIcon />
                            </IconButton>
                        </Stack>
                    </Box>

                    {/* Cards fanning up from the bottom, overflowing past the panel edge */}
                    <Box
                        className="home-cards-stage"
                        sx={{ bottom: { xs: '-120px', sm: '-140px' } }}
                    >
                        <Box className="home-card home-card--left">
                            <img src={homeCard1} alt="" aria-hidden="true" />
                        </Box>
                        <Box className="home-card home-card--center">
                            <img src={homeCard2} alt="" aria-hidden="true" />
                        </Box>
                        <Box className="home-card home-card--right">
                            <img src={homeCard3} alt="" aria-hidden="true" />
                        </Box>
                    </Box>
                </Box>
            </Box>

            {/* About */}
            <Box
                ref={aboutRef}
                className={`home-reveal home-section-about${aboutInView ? ' is-visible' : ''}`}
                sx={{
                    maxWidth: 1200,
                    mx: 'auto',
                    px: { xs: 3, sm: 3, md: 4 },
                    py: { xs: 3, sm: 0 },
                    mt: { xs: '110px', sm: '130px' },
                }}
            >
                <Stack
                    direction={{ xs: 'column', sm: 'row' }}
                    justifyContent="space-between"
                    alignItems={{ xs: 'flex-start', sm: 'flex-end' }}
                    spacing={{ xs: 3, sm: 2 }}
                    sx={{ mb: { xs: 5, sm: 4.5 } }}
                >
                    <Box sx={{ maxWidth: 640 }}>
                        <Typography
                            sx={{
                                fontSize: { xs: '2.25rem', sm: '3rem', md: '3.5rem' },
                                fontWeight: 800,
                                letterSpacing: '-0.03em',
                                lineHeight: 1.08,
                                color: '#fff',
                            }}
                        >
                            El punto de encuentro para coleccionistas.
                        </Typography>
                    </Box>
                    <Typography sx={{ color: 'rgba(255,255,255,0.55)', fontSize: '1rem', maxWidth: 360 }}>
                        PlayBid conecta a tiendas independientes de cartas y coleccionables con compradores de
                        toda la comunidad a través de subastas en vivo, ya sea que estés comprando esa pieza que
                        te falta o vendiendo tu propio inventario.
                    </Typography>
                </Stack>
                <Button
                    component={RouterLink}
                    to="/store/login"
                    startIcon={<StorefrontIcon />}
                    size="large"
                    sx={{
                        ...PURPLE_BUTTON_SX,
                        px: 3.5,
                        py: 1.25,
                    }}
                >
                    Vender con Nosotros
                </Button>
            </Box>

            {/* TCG carousel */}
            <Box
                ref={carouselRef}
                className={`home-reveal home-section-carousel${carouselInView ? ' is-visible' : ''}`}
                sx={{ mt: { xs: '110px', sm: '130px' }, display: 'flex', flexDirection: 'column' }}
            >
                <Box
                    sx={{
                        order: 1,
                        maxWidth: 1200,
                        mx: 'auto',
                        px: { xs: 2, sm: 3, md: 4 },
                        width: '100%',
                        mb: { xs: 2, sm: 5 },
                        textAlign: 'center',
                    }}
                >
                    <Typography
                        sx={{
                            fontSize: { xs: '2.25rem', sm: '3rem', md: '3.5rem' },
                            fontWeight: 800,
                            letterSpacing: '-0.03em',
                            lineHeight: 1.08,
                            color: '#fff',
                            maxWidth: 800,
                            mx: 'auto',
                        }}
                    >
                        Todos los TCG son bienvenidos.
                    </Typography>
                </Box>

                <Box sx={{ order: 2, mt: { xs: 4, sm: 0 }, mb: { xs: 4, sm: 5 } }}>
                    <CardCarousel items={CAROUSEL_ITEMS} />
                </Box>

                <Box
                    sx={{
                        order: 3,
                        maxWidth: 1200,
                        mx: 'auto',
                        px: { xs: 2, sm: 3, md: 4 },
                        width: '100%',
                        textAlign: 'center',
                    }}
                >
                    <Typography sx={{ color: 'rgba(255,255,255,0.55)', fontSize: '1rem', maxWidth: { xs: 'none', sm: 640 }, mx: 'auto' }}>
                        No importa de qué mundo vengas — Pokémon, Yu-Gi-Oh!, Magic, Lorcana, One Piece y
                        más — siempre hay un espacio para tu colección y algo nuevo por descubrir.
                    </Typography>
                </Box>
            </Box>

            {/* Main features */}
            <Box
                ref={featuresRef}
                id="como-funciona"
                className={`home-reveal home-section-features${featuresInView ? ' is-visible' : ''}`}
                sx={{ maxWidth: 1200, mx: 'auto', px: { xs: 2, sm: 3, md: 4 }, mt: { xs: '110px', sm: '130px' } }}
            >
                <Stack
                    direction={{ xs: 'column', sm: 'row' }}
                    justifyContent="space-between"
                    alignItems={{ xs: 'flex-start', sm: 'flex-end' }}
                    spacing={2}
                    sx={{ mb: { xs: 5, sm: 6 } }}
                >
                    <Box sx={{ maxWidth: 640 }}>
                        <Typography
                            sx={{
                                fontSize: { xs: '2.25rem', sm: '3rem', md: '3.5rem' },
                                fontWeight: 800,
                                letterSpacing: '-0.03em',
                                lineHeight: 1.08,
                                color: '#fff',
                            }}
                        >
                            Todo lo que necesitas para vender y coleccionar.
                        </Typography>
                    </Box>
                    <Typography sx={{ color: 'rgba(255,255,255,0.55)', fontSize: '1rem', maxWidth: 320 }}>
                        Sin cuotas de entrada ni tarjetas de crédito. Crea tu cuenta y empieza a pujar o a vender hoy mismo.
                    </Typography>
                </Stack>

                <Stack direction={{ xs: 'column', md: 'row' }} spacing={{ xs: 0, md: 8 }} alignItems="flex-start">
                    <Box sx={{ flex: 1, minWidth: 0, width: '100%' }}>
                        {MAIN_FEATURES.map((feature) => (
                            <FeatureAccordionItem
                                key={feature.key}
                                feature={feature}
                                isOpen={activeFeatureKey === feature.key}
                                onToggle={() =>
                                    setActiveFeatureKey((current) => (current === feature.key ? null : feature.key))
                                }
                            />
                        ))}

                        <Stack direction="row" flexWrap="wrap" gap={1} sx={{ mt: 4 }}>
                            {SECONDARY_FEATURES.map((sf) => (
                                <Chip
                                    key={sf.label}
                                    icon={<sf.icon sx={{ fontSize: '16px !important', color: 'rgba(255,255,255,0.6) !important' }} />}
                                    label={sf.label}
                                    size="small"
                                    sx={{
                                        bgcolor: 'rgba(255,255,255,0.04)',
                                        color: 'rgba(255,255,255,0.6)',
                                        border: '1px solid rgba(255,255,255,0.1)',
                                    }}
                                />
                            ))}
                        </Stack>
                    </Box>

                    <Box
                        sx={{
                            flex: 1,
                            minWidth: 0,
                            width: '100%',
                            display: { xs: 'none', md: 'block' },
                            position: 'sticky',
                            top: 96,
                            opacity: activeFeature ? 1 : 0,
                            transition: 'opacity 0.25s ease',
                        }}
                    >
                        {activeFeature && (
                            <Box key={activeFeature.key} className="feature-image-fade">
                                <FeatureMockupWithMascot feature={activeFeature} />
                            </Box>
                        )}
                    </Box>
                </Stack>
            </Box>

            {/* FAQ */}
            <Box
                ref={contactRef}
                className={`home-reveal home-section-contact${contactInView ? ' is-visible' : ''}`}
                sx={{ maxWidth: 1200, mx: 'auto', px: { xs: 2, sm: 3, md: 4 }, mt: { xs: '110px', sm: '130px' } }}
            >
                <Stack
                    direction={{ xs: 'column', md: 'row' }}
                    alignItems="center"
                    justifyContent="space-between"
                    spacing={{ xs: 6, md: 4 }}
                >
                    <Box sx={{ maxWidth: 480, textAlign: { xs: 'center', md: 'left' } }}>
                        <Typography
                            sx={{
                                fontSize: { xs: '2.25rem', sm: '3rem', md: '3.5rem' },
                                fontWeight: 800,
                                letterSpacing: '-0.03em',
                                lineHeight: 1.08,
                                color: '#fff',
                                mb: 2.5,
                            }}
                        >
                            ¿Tienes alguna pregunta?
                        </Typography>
                        <Typography sx={{ color: 'rgba(255,255,255,0.55)', fontSize: '1rem', mb: 4 }}>
                            Ya seas un coleccionista o unatienda, nuestro equipo está disponible para ayudarte con dudas
                            sobre publicar articulos, reclamar un articulo o cómo empezar una subasta.
                        </Typography>
                        <Button
                            component={RouterLink}
                            to="/faq"
                            size="large"
                            sx={{
                                ...PURPLE_BUTTON_SX,
                                px: 3.5,
                                py: 1.25,
                            }}
                        >
                            Preguntas Frecuentes
                        </Button>
                    </Box>
                    <Box sx={{ position: 'relative', width: { xs: 220, sm: 260, md: 300 }, flexShrink: 0 }}>
                        <Box
                            component="img"
                            src={mascotPreguntas}
                            alt="Mascota PlayBid pensando"
                            className="bidoo-faq-home"
                            sx={{  display: 'block', position: 'relative', zIndex: 1 }}
                        />
                        <Box
                            component="img"
                            src={mascotQuestionMark}
                            alt=""
                            aria-hidden="true"
                            className="faq-question-mark"
                        />
                        <Box
                            component="img"
                            src={mascotQuestionMark2}
                            alt=""
                            aria-hidden="true"
                            className="faq-question-mark-2"
                        />
                        
                    </Box>
                </Stack>
            </Box>

            {/* Minimal footer */}
            <Stack
                className="home-section-footer"
                direction={{ xs: 'column', sm: 'row' }}
                justifyContent="center"
                alignItems="center"
                spacing={{ xs: 1, sm: 1.5 }}
                sx={{
                    maxWidth: 1200,
                    mx: 'auto',
                    mt: { xs: '130px', sm: '150px' },
                    px: { xs: 2, sm: 3, md: 4 },
                }}
            >
                <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.4)' }}>
                    © {new Date().getFullYear()} PlayBidTCG
                </Typography>
                <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.25)', display: { xs: 'none', sm: 'block' } }}>
                    ·
                </Typography>
                <Typography
                    component="button"
                    type="button"
                    onClick={() => setPrivacyOpen(true)}
                    variant="body2"
                    sx={{
                        color: 'rgba(255,255,255,0.4)',
                        background: 'none',
                        border: 'none',
                        p: 0,
                        font: 'inherit',
                        cursor: 'pointer',
                        '&:hover': { color: ELECTRIC_PURPLE },
                    }}
                >
                    Aviso de Privacidad
                </Typography>
            </Stack>

            <TermsDialog
                open={privacyOpen}
                onClose={() => setPrivacyOpen(false)}
                title="Aviso de Privacidad"
                url={`${process.env.PUBLIC_URL}/legal/aviso-de-privacidad.md`}
            />
        </Box>
    );
}

export default HomePage;
